import Vue from "vue"
import Vuex from "vuex"
import settings from "./settings"
import auth from "./auth"
import user from "./user"
import referencePropertiesList from "./referencePropertiesList"
import notifications from "./notifications"
import userLocalSettings from "./userLocalSettings"
import tickets from "./tickets"
import clientPortfolio from "./clientPortfolio"
import fileViewer from "./FileViewer"
import orderDetail from "./orderDetail"
import companyDetail from "./companyDetail"
import tablesSettings from "./tablesSettings"
import task from "./task"
Vue.use(Vuex)

export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    modules: {
        settings,
        auth,
        user,
        userLocalSettings,
        referencePropertiesList,
        notifications,
        tickets,
        clientPortfolio,
        fileViewer,
        orderDetail,
        companyDetail,
        tablesSettings,
        task,
    }
})
